import { render, staticRenderFns } from "./registSetName.vue?vue&type=template&id=5678f6e2&scoped=true&"
import script from "./registSetName.vue?vue&type=script&lang=js&"
export * from "./registSetName.vue?vue&type=script&lang=js&"
import style0 from "./registSetName.vue?vue&type=style&index=0&id=5678f6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5678f6e2",
  null
  
)

export default component.exports